module.exports = __webpack_public_path__ + "img/arcade-v3.dc031b27.jpg";